import { AvForm } from 'availity-reactstrap-validation'
import RenderFields from '../../../../../CMSComponent/Forms/renderFields'
import { ConvertToFAQTicket } from '../../../../../Helper/raiseTicketHelper'
import { primary_color } from '../../../../../Helper/uiHelper'
import { useRef, useState } from 'react'
import { request } from '../../../../../Redux/Sagas/requests/api'
import { cms, isSuccessResponse } from '../../../../../helper'
import { Button } from 'reactstrap'
import { useHistory } from 'react-router-dom'

export const ConvertToFAQ = ({ defaultValue, onCloseForm, onCloseTicket }) => {
  const history = useHistory()
  const saveNclose = useRef()

  const [loading, setLoading] = useState(false)
  const [defaultId, setDefaultId] = useState()

  const onSubmit = (values) => {
    let data = {
      ...values,
    }
    if (defaultId) {
      data = {
        ...data,
        id: defaultId,
      }
    }
    request('insert-repeating-grid-data', 'POST', {
      is_nested: true,
      data: {
        faqs: [data],
      },
    }).then((res) => {
      if (isSuccessResponse(res, 'FAQ created successfully!')) {
        if (!defaultId) {
          setDefaultId(res?.data?.data)
          if (saveNclose.current) {
            onCloseTicket(true)
          } else {
            onCloseTicket()
          }
        }
      }
    })
  }
  return (
    <div>
      <Button
        style={{ background: primary_color }}
        className='mb-4'
        onClick={() => {
          history.push('/query-types-list')
        }}>
        {cms('heading.query_types') || 'Manage Queries'}
      </Button>
      <div style={{ color: primary_color }} className='body1 font-weight-bold mb-3'>
        Edit FAQ
      </div>
      <AvForm
        onValidSubmit={(e, values) => {
          onSubmit(values)
        }}>
        <RenderFields allForm={[ConvertToFAQTicket]} content={[ConvertToFAQTicket]} defaultFormValue={defaultValue} />
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            type='submit'
            id='save-button'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              saveNclose.current = true
              const ele = document.getElementById('save-button')
              if (ele) {
                ele.click()
              }
            }}
            type='submit'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            Save & Close
          </button>
        </div>
      </AvForm>
    </div>
  )
}
